import { printGAC } from '@/apis/three-liability-insurance'
import Insurance from './../router/insurance'

export interface serviceTagSatusItem {
  readonly text: string
  readonly background: string
}

export interface tagSatus<T> {
  [index: number]: T
}

export interface serviceItem {
  serial_number: string
  policy_begin_date: string
  policy_end_date: string
  policy_no: string
  pay_order_no: string
  insurant_type: string
  insurant_name: string
  insurant_certi_type: string
  insurant_certi_no: string
  insurant_email: string
  insurant_phone_no: string
  insurant_birth: string
  insurant_address: string
  insurant_sex: string
  operator: string
  erp_sale_no: string
  erp_receipt_no: string
  status: number
  insurance_type: number
  product_name?: string
  voucher_time?: string // 人保凭证上传时间
  voucher_url?: string // 人保凭证url
  api_type?: number // // 1  旧平安  2人保  3 平安2024线上 4 平安2024线下
}
export interface OperatorItemType {
  status: string
  old_id_card: string
  name: string
  id_card: string
  mobile?: string
  phone: string
  uuid?: string
}

export type serviceItem2 = Partial<serviceItem>

export interface printGACData {
  url: string
}

export interface lastXcareItem {
  end_at: string
  start_at: string
  status: string | number
  status_text: string
  type_name: string
  type: number
  policy_no: string // 保单号
  service_type: number // 1 其他  2 安心保
}

export interface lastXcareItemFront extends lastXcareItem {
  background?: string
}

export enum serviceType {
  ThirdPartyLiabilityService = 'ThirdPartyLiabilityService',
  ExtremeService = 'ExtremeService',
  AllInclusiveService = 'AllInclusiveService',
}

export interface insuranceTypeItem {
  [index: string]: string
}

export interface InsurantTypeOptionsItem {
  label: string
  value: string
}
// 人保三者险 保单批改params
export interface EditPPICThirdPartyLiabilityParams {
  policy_no: string
  insurant_type: string
  insurant_name: string
  insurant_certi_no: string
}

// 平安三责险批改保单
export interface ChangePingan2024ThirdPartyLiabilityInformationParams {
  policy_no: string
  updated_by: string
  name: string
  email: string
  phone: string
  personnel_type: string
  certificate_type: string
  certificate_no: string
  link_man_name?: string
  birthday?: string
  address?: string
}
